// extracted by mini-css-extract-plugin
export default {"box_number":"BoxNumberCell_box_number__7gcDe","box_number_outer":"BoxNumberCell_box_number_outer__bCuey"};